import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const SpectroscopicDiffractionMicroscopicTechniques = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Spectroscopic, Diffraction, and Microscopic Techniques"
    videos={[
      "https://www.youtube.com/embed/gGRMtq7hvHc",
      "https://www.youtube.com/embed/zuUvQN8KXOk",
      "https://www.youtube.com/embed/4e8EB1jzHIQ"
    ]}
    takeaways={[
      { text: "Mostly UV-Spectroscopy is Important." },
      { text: "Learn both the long questions UV and XRD spectroscopy." }
    ]}
    questions={[
      "With a neat diagram explain the principle and various electronic transition involved in UV-visible spectroscopy. How does chromophore and auxochrome effects the wavelength(max).",
      "Discuss the working principle, limitations and application of UV-Visible spectrophotometry.",
      "Explain using Beer-Lambert law, how concentration of an analyte is obtained. Discuss the electronic excitations in UV-Visible spectroscopy using energy level diagram."
    ]}
    exampleVideos={[]}
  />
);
}

export default SpectroscopicDiffractionMicroscopicTechniques;
